import { styled,
    experimental_sx as sx
 } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import BigLabel from '../../shared/BigLabel';
import BlueSkeleton from '../../shared/BlueSkeleton';
import DropDownButton, { DropDownMenu } from '../../shared/DropDownButton';
import DownloadButton from '../../shared/DownloadButton';
import { VisionAwareContext } from '../../../context/visionaware-context';
import { useTranslation } from 'react-i18next';

const exportMenus: DropDownMenu[] = [{ label: 'PDF', value: 'pdf' }, { label: 'CSV', value: 'csv' }];

const OverviewText = styled(Typography)(({ theme }) => theme.unstable_sx({
    fontWeight: '500',
    fontSize: {
        xs: 14,
        md: 16,
        textTransform: 'uppercase',
    },
    color: '#686868'
}));

const OverviewCell = styled(Stack)(({ theme }) => theme.unstable_sx({
    alignItems: 'center',
    paddingTop: '10px',
    paddingBottom: '15px',
    flex: {
        xs: '1 0 99%',
        xl: '1 0 23%'
    }
}));

const OverviewRow = styled(Stack, {})({
    justifyContent: 'space-evenly',
    width: '100%',
    flexWrap: 'wrap'
});

export default function OverviewCard() {
    const { t } = useTranslation();

    return (
        <VisionAwareContext.Consumer>{
            ({ status, data, isFetching, error }) =>
                
                <Grid item={true} xs={12} >
                    <FFPaper
                        elevation={3}
                        sx={{
                            position: 'relative',
                            height: '100%',
                            pl: 3,
                            pr: 3,
                            mb: 1,
                            pt: 0
                        }}
                    >
                        <Stack direction="row" spacing={1}
                            sx={{
                                mt: 2,
                                mb: 2,
                                flexWrap: 'wrap',
                                fontSize: '16px',
                                textTransform: 'uppercase'
                            
                            }}
                        >
                            <Title minWidth={300} info={t('va_overview_tooltip')}>{t('va_overview_title')}</Title>
                        </Stack>

                        <OverviewRow direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem={true} />}>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.totalNewEnrollments.toLocaleString() }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_1_1')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.peopleDeterred }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_1_2')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.peopleApprehended }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_2_3')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.seriousOffenderEvents }
                                 </BigLabel>
                                 <OverviewText>{t('va_overview_row_1_5')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && '$' + (data?.totalLossDeterred ? Math.round(+data.totalLossDeterred).toLocaleString() : 0)}
                                 </BigLabel>
                                 <OverviewText>{t('va_overview_row_1_3')}</OverviewText>
                            </OverviewCell>

                        </OverviewRow>

                        <Divider />

                        <OverviewRow direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem={true} />}>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.totalEvents.toLocaleString() }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_2_1')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.totalEventsTagged }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_2_2')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.totalROITimeSaved }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_2_5')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.taggedSeriousOffenderEvents }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_1_4')}</OverviewText>
                            </OverviewCell>

                            <OverviewCell>
                                <BigLabel>
                                    { isFetching && <BlueSkeleton width={300} sx={{ml: 'auto', mr: 'auto'}} /> }
                                    { status === 'success' && !isFetching && data?.repeatPeople }
                                </BigLabel>
                                <OverviewText>{t('va_overview_row_2_4')}</OverviewText>
                            </OverviewCell>

                        </OverviewRow>
                    </FFPaper>
                </Grid>
        }

        </VisionAwareContext.Consumer>
    )

}
